import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import { Box, MenuItem, Select, Stack, Tooltip, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserProfileDialog from "../../components/dialog/UserProfileKyc";
import useDebounce from "../../hooks/use.debounce";
import { maskCardNumber } from '../../utils/common';
import { CustomSearchInput, FORM_SELECTFIELD_STYLES, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES, USER_STATUS_FILTER } from "../../utils/constant";
import { getListing, updateKycDocStatus, userkycDetails } from './action';
import { updateKyc } from "./kycSlice";
import CustomPagination from "../../utils/CustomPagination";
function EnhancedTableHead(props) {
    const { order, orderBy } = props;
    const headCells = [

        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "Full Name",
            type: "",
        },
        {
            id: "dob",
            numeric: false,
            disablePadding: true,
            label: "Date of Birth",
            type: "",
        },
        {
            id: "address",
            numeric: false,
            disablePadding: true,
            label: "Address",
            type: "",
        },
        {
            id: "Uid",
            numeric: false,
            disablePadding: true,
            label: "Aadhaar Number",
            type: "",
        },

        {
            id: "pan",
            numeric: false,
            disablePadding: true,
            label: "PAN Number",
            type: "",
        },
        {
            id: "status",
            numeric: false,
            disablePadding: true,
            label: "Status",
            type: "",
        },
        {
            id: "action",
            numeric: false,
            disablePadding: true,
            label: "Action",
            type: "",
        },
    ];
    return (
        <TableHead className="hideActionSort">
            <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                IconComponent={() => null}>
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


const Kyc = () => {
    const dispatch = useDispatch();
    const [modelOpen, setModelOpen] = useState(false);
    const [jsonData, setJsonData] = useState({});
    const {
        limit,
        page,
        sort_key,
        totalPages,
        listing,
        totalCount,
        filters } = useSelector((state) => state.kycSlice);
    const debouncedSearch = useDebounce(filters.search, 500);
    useEffect(() => {
        dispatch(getListing());
    }, [])
    const handleChange = (value) => {
        dispatch(updateKyc({ page: value - 1 }));
        dispatch(getListing());
    };
    const handleSearch = (event) => {
        if (event.target.value) {
            dispatch(updateKyc({ filters: { ...filters, search: event.target.value }, page: 0 }));
        } else {
            dispatch(updateKyc({ filters: { ...filters, search: "" }, page: 0 }));
            dispatch(getListing());
        }

    };

    const handleSearchClear = () => {
        dispatch(updateKyc({ filters: { ...filters, search: "" } }));
        dispatch(getListing());
    };
    useEffect(() => {
        if (debouncedSearch)
            dispatch(getListing())
    }, [debouncedSearch, dispatch]);
    const handleChangePerPage = (event, value) => {
        dispatch(updateKyc({ limit: event.target.value, page: 0 }));
        dispatch(getListing());
    };
    const handleApproveKycHistory = (payload) => {
        dispatch(updateKycDocStatus(payload));
        setModelOpen(false);
    }

    const handleUpdateUserInfo = (payload) => {
        dispatch(userkycDetails(payload));
        setModelOpen(false);
    }
    return <>

        <Stack direction={"column"} gap={2}>
            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{
                    minHeight: '42px', paddingX: '16px',
                }}
            >
                <Typography className="page-title" variant="h1">Know Your Customer (KYC)</Typography>
                <Stack direction="row" justifyContent="flex-end" gap={2} flexWrap="wrap">
                    <CustomSearchInput
                        className="inputSearch sContrl p-0"
                        value={filters.search}
                        placeholder={"Search here..."}
                        handleSearch={handleSearch}
                        clearSearch={handleSearchClear}
                        startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
                    />
                    <Select
                        sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '200px', width: '200px' }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    borderRadius: "8px",
                                    mt: 1,
                                },
                            },
                        }}
                        value={filters.status || ''}
                        name="tableName"
                        onChange={(e) => {
                            dispatch(updateKyc({ filters: { ...filters, status: e.target.value } }));
                            dispatch(getListing());
                        }}
                        displayEmpty
                        defaultValue={""}
                    >
                        <MenuItem value="" disabled hidden>
                            Status
                        </MenuItem>

                        <MenuItem value=" " >
                            Status (All)
                        </MenuItem>


                        {USER_STATUS_FILTER.map((v) => <MenuItem key={v} value={v == "Approved" ? "Completed" : v} >
                            {v == "Approved" ? "Completed" : v}
                        </MenuItem>)}
                    </Select>
                    <Tooltip title="Refresh listing">
                        <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692', mt: 1.5 }}
                            onClick={() => {
                                dispatch(updateKyc({ filters: {}, removeUsers: Math.random() }))
                                dispatch(getListing());
                            }}
                        />
                    </Tooltip>
                </Stack>
            </Stack>
            <TableContainer stickyHeader >
                <Table stickyHeader aria-label="simple table">
                    <EnhancedTableHead
                        order={"test"}
                        orderBy={sort_key}
                        onRequestSort={() => { }}
                        numSelected={0}
                        onSelectAllClick={function (

                        ) {
                            throw new Error("Function not implemented.");
                        }}
                    />

                    <TableBody>
                        {listing?.length > 0 ? (
                            listing?.map((row) => {
                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row?.id}
                                        sx={TABLE_BODY_ROW_MUI_STYLES}>
                                        <TableCell component="td" scope="row" className="capitalize-first-letter" >
                                            {row?.name}
                                        </TableCell>

                                        <TableCell component="td" align="left" >{row.dob || "N/A"}</TableCell>

                                        <TableCell component="td" align="left" >{row.address + " " + row.city + " " + row.state}</TableCell>
                                        <TableCell component="td" align="left">{maskCardNumber(row.aadharNumber)}</TableCell>
                                        <TableCell component="td" align="left">{maskCardNumber(row.panNumber)}</TableCell>
                                        <TableCell component="td" align="left"><button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button></TableCell>
                                        <TableCell component="td" align="left"> <span className="viewIcon" onClick={() => {
                                            setJsonData(row)
                                            setModelOpen(true);
                                        }}>
                                            View Details
                                        </span></TableCell>
                                    </TableRow>

                                )
                            })) : (
                            <TableRow colSpan={10}>
                                <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                                    <Typography
                                        color="inherit"
                                        variant="subtitle1"
                                        alignItems={"center"}
                                        component="h3"
                                    >
                                        No Data found!
                                    </Typography>

                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>

            </TableContainer>
        </Stack>
        <Stack
            sx={{
                background: 'transparent',
                height: '60px',
                border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
                count={Math.ceil(totalPages / limit) || 0}
                onChange={handleChange}
                currentPage={page}
                handleChangePerPage={handleChangePerPage}
                limit={limit}
                listingCount={listing?.length}
                totalCount={totalCount}
                defaultPage={1} siblingCount={1} boundaryCount={1} />
        </Stack>

        <UserProfileDialog open={modelOpen} handleClose={() => setModelOpen(false)} data={jsonData} handleApproveKycHistory={handleApproveKycHistory} handleUpdateUserInfo={handleUpdateUserInfo}/>
    </>
}
export default Kyc;